/**
 * Icon type referring to open in new tab icon
 * @type {string}
 */
export const TYPE_OPEN_IN_NEW_TAB = 'open-in-new-tab';

/**
 * Icon type referring to inverted triangle icon for dropdown
 * @type {string}
 */
export const TYPE_CHEVRON_DOWN = 'chevron-down';

/**
 * Icon type referring to copy link icon in share design modal
 * @type {string}
 */
export const TYPE_COPY_LINK_CHAIN = 'copy-link-chain';

/**
 * Icon type denoting the selected option
 * @type {string}
 */
export const TYPE_SELECTED_OPTION = 'selected-option';

/**
 * Icon type referring to share design link icon in share design modal header
 * @type {string}
 */
export const TYPE_SHARE_NODES = 'share-nodes';

/**
 * Icon type referring to share app link icon
 * @type {string}
 */
export const TYPE_SHARE_ARROW = 'share-arrow';

/**
 * Icon type referring to any downloadble file
 * @type {string}
 */
export const TYPE_DOWNLOAD_FILE = 'download-file';

/**
 * Icon type referring to any pdf document
 * @type {string}
 */
export const TYPE_PDF_DOCUMENT = 'pdf-document';

/**
 * Icon type referring to any additional resource file that can be opened in a new tab
 * @type {string}
 */
export const TYPE_OPEN_IN_NEW_TAB_SMALL = 'open-in-new-tab-small';

/**
 * Icon type referring to LTSpice simulation file
 * @type {string}
 */
export const TYPE_SPANNER_TOOL = 'spanner-tool';
